/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

export enum VideoCodec {
  H264 = 0,
  VP8 = 1,
  VP9 = 2
}

export type VideoCodecType = 'H264' | 'VP8' | 'VP9';